export enum ServiceEnum {
  Fanzone = 1,
  Rights = 2,
  Nft = 3,
  Licensing = 4,
  ContentId = 5,
  Distribution = 6,
  Tipping = 7,
  WinampLink = 9,
  SocialMediaManager = 10,
  WebsiteBuilder = 11,
}

export type Service =
  | "contentId"
  | "distribution"
  | "fanzone"
  | "licensing"
  | "nft"
  | "rights";

export type CollectionService = "distribution" | "fanzone";

export type ServiceBase = {
  id: ServiceEnum;
  name: string;
};

export type ServiceDetails = ServiceBase & {
  requiredArtistRoles: Array<number>;
  requiredFields: Array<string>;
  requiredProducerRoles: Array<number>;
};

export type Services = Record<Service, ServiceDetails>;

export type ServiceStatusDetails = {
  activated: boolean;
};

export type ServiceStatus = Record<Service, ServiceStatusDetails>;
